import { FormControlLabel, Stack, Switch } from "@mui/material";
import { useController, type UseControllerProps } from "react-hook-form";

import { type WorkerAvailabilityCriteriaValues } from "../../types";
import { WorkerAutoBookInfo } from "./WorkerAutoBookInfo";

type FieldValue = Pick<WorkerAvailabilityCriteriaValues, "autoBookingIsEnabled">;

type FieldName = "autoBookingIsEnabled";

export interface WorkerAutoBookSwitchProps extends UseControllerProps<FieldValue, FieldName> {
  isLoading: boolean;
  isDisabled: boolean;
}

export function WorkerAutoBookSwitch(props: WorkerAutoBookSwitchProps) {
  const { name, control, isDisabled, isLoading } = props;
  const {
    field,
    formState: { isSubmitting },
  } = useController<FieldValue, FieldName>({
    name,
    control,
  });
  return (
    <Stack spacing={1}>
      <WorkerAutoBookInfo />
      <FormControlLabel
        labelPlacement="start"
        sx={{ justifyContent: "space-between", width: "100%" }}
        control={
          <Switch
            checked={field.value}
            disabled={isSubmitting || isDisabled || isLoading}
            onChange={field.onChange}
          />
        }
        label="Enable Auto-Book"
      />
    </Stack>
  );
}
